import React, { FC } from 'react';
import {
    Form, Typography,
} from 'antd';
import { LoginFormValues } from 'types';
import { SInputGroup, Actions } from '../LoginPage.styles';
import { CustomInput } from '../../../components/CustomInput/CustomInput';
import { CustomButton } from '../../../components/CustomButton/CustomButton';

type LoginFormProps = {
    onFinish: (values: LoginFormValues) => void,
    error?: string,
    onForgotPasswordClick?: () => void,
    usernameVal?: string,
    form?: any
};

const { Text } = Typography;

const LoginForm: FC<LoginFormProps> = ({ onFinish, error, onForgotPasswordClick, usernameVal, form }) => (
    <Form
        form={form}
        onFinish={onFinish}
        autoComplete="off"
        layout="vertical"
        requiredMark={false}
    >
        <Text style={{display:'block', textAlign:'center'}} type="danger">{error}</Text>
        <SInputGroup>
            <Form.Item
                label="Email:"
                name="username"
                validateTrigger={['onBlur', 'onChange']}
                validateFirst
                rules={[
                    {
                        required: true,
                        message: 'Please input your email',
                    }
                ]}
            >
                <CustomInput
                    type="text"
                    bgColor="white"
                    autoComplete="new-password"
                />
            </Form.Item>
            <Form.Item
                label="Password:"
                name="password"
                rules={[
                    {
                        required: true,
                        message: 'Please input your password',
                    },
                ]}
            >
                <CustomInput
                    type="password"
                    bgColor="white"
                    autoComplete="new-password"
                    data-testid="passwordInput"
                />
            </Form.Item>
        </SInputGroup>

        <Form.Item>
            <CustomButton type="primary" block buttonSize="large" htmlType="submit" >
                Log in
            </CustomButton>
        </Form.Item>

        <Actions>
            <span 
                style={{ 
                    cursor: 'pointer', 
                    color: '#1890ff',
                    textDecoration: 'underline'
                }}
                onClick={onForgotPasswordClick}
            >
                Forgot Password?
            </span>
        </Actions>

    </Form>
);

export default LoginForm;
